import { replaceBackendWithFrontendUrl } from "./misc";

export const getYoastHead = (pageData) => {
  if (!pageData) return null;

  // If we have the parsed JSON version, use it to create a clean head section
  if (pageData.yoast_head_json) {
    // Create a copy of the JSON data to modify
    const yoastData = { ...pageData.yoast_head_json };

    // Replace backend URLs with frontend URLs in all relevant fields
    if (yoastData.og_url) {
      yoastData.og_url = replaceBackendWithFrontendUrl(yoastData.og_url);
    }

    if (yoastData.schema) {
      const schemaStr = JSON.stringify(yoastData.schema);
      const updatedSchemaStr = replaceBackendWithFrontendUrl(schemaStr);
      yoastData.schema = JSON.parse(updatedSchemaStr);
    }

    const {
      title,
      description,
      robots,
      og_locale,
      og_type,
      og_title,
      og_description,
      og_url,
      og_site_name,
      article_publisher,
      article_modified_time,
      twitter_card,
      schema,
    } = yoastData;

    return (
      <>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        {robots && (
          <meta
            name="robots"
            content={Object.entries(robots)
              .map(([key, value]) => {
                if (typeof value === 'boolean') {
                  return value ? key : `no${key}`;
                }
                return value;
              })
              .join(', ')}
          />
        )}
        {og_locale && <meta property="og:locale" content={og_locale} />}
        {og_type && <meta property="og:type" content={og_type} />}
        {og_title && <meta property="og:title" content={og_title} />}
        {og_description && (
          <meta property="og:description" content={og_description} />
        )}
        {og_url && <meta property="og:url" content={og_url} />}
        {og_site_name && <meta property="og:site_name" content={og_site_name} />}
        {article_publisher && (
          <meta property="article:publisher" content={article_publisher} />
        )}
        {article_modified_time && (
          <meta
            property="article:modified_time"
            content={article_modified_time}
          />
        )}
        {twitter_card && <meta name="twitter:card" content={twitter_card} />}
        {schema && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        )}
      </>
    );
  }

  // Fallback to the raw HTML string if JSON is not available
  if (pageData.yoast_head) {
    // Replace backend URLs in the raw HTML string
    const updatedYoastHead = replaceBackendWithFrontendUrl(pageData.yoast_head);

    // Create a temporary div to parse the HTML string
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = updatedYoastHead;

    // Extract meta tags, title, and scripts
    const metaTags = tempDiv.querySelectorAll('meta');
    const title = tempDiv.querySelector('title');
    const scripts = tempDiv.querySelectorAll('script');

    return (
      <>
        {title && <title>{title.textContent}</title>}
        {Array.from(metaTags).map((meta, index) => {
          const props = {};
          Array.from(meta.attributes).forEach(attr => {
            props[attr.name] = attr.value;
          });
          const key = meta.getAttribute('name') || meta.getAttribute('property') || index;
          return <meta key={key} {...props} />;
        })}
        {Array.from(scripts).map((script, index) => {
          if (script.type === 'application/ld+json') {
            return (
              <script
                key={script.getAttribute('src') || index}
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: script.textContent }}
              />
            );
          }
          return null;
        })}
      </>
    );
  }

  return null;
};